export enum DepartmentTypeEnum {
  Vessel = 1,
  LandBased = 2,
}
